/**
 * Google Analytics 4.
 *
 * 1. Crie a propriedade GA4 em https://analytics.google.com e copie o
 *    "ID da métrica" (formato G-XXXXXXXXXX).
 * 2. Cole o ID abaixo. Enquanto estiver vazio, nada é carregado e o banner
 *    de cookies não aparece.
 *
 * O script só é carregado depois que o visitante aceita os cookies
 * (banner em components/CookieConsent.js), conforme a LGPD.
 */
export const GA_MEASUREMENT_ID = 'G-EEGCT0S5LE'; // propriedade "Site varellasambista.com.br" (conta Varella Sambista)

export const isAnalyticsConfigured = () => /^G-[A-Z0-9]+$/i.test(GA_MEASUREMENT_ID);

export const CONSENT_KEY = 'varella-cookie-consent';

export const getConsent = () => {
  try {
    return localStorage.getItem(CONSENT_KEY); // 'accepted' | 'declined' | null
  } catch {
    return null;
  }
};

export const setConsent = (value) => {
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch {
    /* modo privado ou storage bloqueado: segue sem persistir */
  }
};

export function loadAnalytics() {
  if (!isAnalyticsConfigured() || window.__gaLoaded) return;
  window.__gaLoaded = true;

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID, { anonymize_ip: true });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);
}
